import React from 'react';
import './HouseDetailsBottom.scss'
import Experience from "./Experience/Experience";
import Amenities from "./Amenities/Amenities";
import VideoWalkthrough from "./VideoWalkthrough/VideoWalkthrough";
import Sidebar from "./Sidebar/Sidebar";
import Neighborhood from "./Neighborhood/Neighborhood";

const HouseDetailsBottom = () => {
	return (
		<>
			<section className="details-grid">

				<div className="content-left">
					<Experience />
					<Amenities />

				</div>

				<Sidebar />

			</section>

			<div className="content-center">
				<VideoWalkthrough />
				<Neighborhood />
			</div>
		</>
	);
};

export default HouseDetailsBottom;